import { Format } from "@redriver/cinnamon";
import React, { useMemo } from "react";
import moment from "moment";
import { Button, Icon } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { BookingRoutes } from "constants/routes";

const BookingBlock = ({ booking }) => {
  const history = useHistory();
  const daysDuration = useMemo(() => {
    return moment(booking.return).diff(moment(booking.departure), "days");
  }, [booking]);

  return (
    <section className="booking-summary-card">
      <header>
        <h5 className="booking-ref">{booking.ref}</h5>
        <span className="booking-title">
          {booking.typeName}{" "}
          {booking.destination ? `to ${booking.destination}` : ""}
        </span>
      </header>
      <div className="booking-summary">
        <p>
          Departure <Format.Date value={booking.departure} /> for {daysDuration}{" "}
          days by {booking.transportMethodName} for {booking.passengerCount}{" "}
          people
        </p>
      </div>
      <footer>
        <span>{booking.customer}</span>
        <Button
          className="rounded-button booking-btn"
          size="mini"
          compact
          onClick={() => history.push(BookingRoutes.Booking(booking.id))}
        >
          View Booking
          <Icon name="triangle right" />
        </Button>
      </footer>
    </section>
  );
};

export default BookingBlock;
